import { extraErrorDataIntegration, captureConsoleIntegration, reportingObserverIntegration, browserTracingIntegration, makeBrowserOfflineTransport, makeFetchTransport, } from "@sentry/browser";
import { ignoreGDKErrors } from './ignoreGDKErrors';
const getIntegrations = () => [
    extraErrorDataIntegration(),
    browserTracingIntegration(),
    reportingObserverIntegration(),
    captureConsoleIntegration({ levels: ['error'] }),
];
export const getRegisterConfig = ({ dsn, release, stage, ignoreCodes, injected }) => ({
    integrations: getIntegrations(),
    transport: makeBrowserOfflineTransport(makeFetchTransport),
    dsn,
    environment: stage,
    release,
    attachStacktrace: true,
    beforeSend: ignoreCodes ? ignoreGDKErrors(ignoreCodes) : undefined,
    ...injected,
});
//# sourceMappingURL=registerSentry.js.map